import { MenuProps } from "antd";
import { useMemo } from "react";
import { DropdownOptionsEventProps } from "../components/DropdownOptionsEvent/DropdownOptionsEvent";
import { useRole } from "../../../../features/roles/useRole";

export default function useDropdownItems({
  goToDetails,
  itemId,
  onModify,
  onDelete,
}: DropdownOptionsEventProps) {
  const { isAdmin } = useRole();
  const items = useMemo(() => {
    const _items: MenuProps["items"] = [
      {
        key: "1",
        label: (
          <a
            onClick={(e) => {
              e.stopPropagation();
              goToDetails(itemId);
            }}
          >
            Voir l'Ã©vÃ©nement
          </a>
        ),
      },
    ];

    if (isAdmin) {
      _items.push({
        key: "2",
        label: (
          <a
            onClick={(e) => {
              e.stopPropagation();
              onModify(itemId);
            }}
          >
            Modifier l'Ã©vÃ©nement
          </a>
        ),
      });
      _items.push({
        key: "3",
        danger: true,
        label: (
          <a
            onClick={(e) => {
              e.stopPropagation();
              onDelete(itemId);
            }}
          >
            Supprimer
          </a>
        ),
      });
    }

    return _items;
  }, [isAdmin, goToDetails, itemId, onModify, onDelete]);
  return items;
}
